<!-- html/giftshop/08_shop_card_info.html -->


<template>
  <div>
    
    <common-header title="선물하기" :showTitle="true" :showLeftMenu="true" :showCart="false" :cart="cartInfo" :showBack="true" :showHome="true"/>

    <main class="giftshop shop-coupon-info">
        <div class="container">
            <div>
              <!-- 선물 정보 -->
              <div class="gift-info">
                  <!-- <img src="@/assets/img/img-card-default.png" class="gift-img" alt=""> -->
                  <img v-bind:src="getImage(item.cardImg)" alt="">
                  <p class="gift-info01">{{item.cardItemName}}</p>
                  <p class="gift-info02"></p>
              </div>
              <!--// 선물 정보 -->
              <div class="btn-group02">
                  <button class="btn  btn-full btn-primary" @click="goGift()">결제 및 선물하기</button>
              </div>
            </div>
            <!--//추천선물 -->
            <!-- <recommend-bottom/> -->
        </div>

        <!-- 장바구니 알림 팝업 -->
        <div class="pop-alert pop-cart">
            <div class="container">
                <div class="pop-header clearfix">
                    <div class="f-left">알림</div>
                    <div class="f-right">
                        <button type="button" class="pop-close" @click="closePopAlert();"><span class="blind">팝업닫기</span></button>
                    </div>
                </div>
                <div class="pop-content">
                    <p>
                        상품이 장바구니에 담겼습니다.
                    </p>
                    <button type="button" class="pop-close" @click="closePopAlert();">확인</button>
                </div>
            </div>
        </div>
        <!--//장바구니 알림 팝업 -->
    </main>
  </div>
</template>

<script>


// import DetailCha from './details/DetailCha'
// import DetailCard from './details/DetailCard'
import RecommendBottom from '../common/RecommendBottom.vue';

import {GiftShopConfig} from '@/store/Constraints';
import {GiftType,PayMenuType} from "@/components/AppConstants";

export default {
  // props:['item'],
  components: {RecommendBottom},
  computed: {
      cartInfo(){
        return {url:'/giftshop/cart',orderType:'EGIFT'}
    },
      item(){
        return this.$store.getters[GiftShopConfig.GIFT_SELECTED_ITEM];
      }
  },
  created(){    
    console.log(`CardDetail.created -> item:${JSON.stringify(this.item)})`);    
  },
  mounted: function(){
    this.totalPrice = this.count * this.price;
  },
  methods: {
    countPlus: function() {
      this.count = this.count + 1;
      this.totalPrice = this.price * this.count;
    },
    countMin: function(){
      if(this.count > 1) this.count = this.count - 1;
      this.totalPrice = this.price * this.count;
    },
    getImage: function (image) {
        return image.indexOf("http") >= 0 ? image : require('@/assets/img/img-card-default.png');
    },
    
    goGift(){
      var giftItem = {
            itemCode : this.item.cardItemId,
            itemName : this.item.cardItemName,
            price : 0,
            quantity : 1,
            image: this.item.cardImg,
            optionList:[]
        }

        this.$router.replace(
            {
                path:'/giftshop/gift',
                name:'giftshop_gift',
                // params:{payMenuType:'CARD',itemList:itemList,giftItem:this.item}
                params:{payMenuType:PayMenuType.Card,giftItemType: GiftType.Card,giftItem:giftItem}
            }
        );
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/giftshop/gongchaCard/CardDetail.vue